import { CodeToText } from 'element-china-area-data'
const changeMarketType = {
  state: {
    area: localStorage.getItem('selectedOptionsCity') ? CodeToText[localStorage.getItem('selectedOptionsCity').split(',')[1]] : '盐城',
    changeMarketType: 0,
    position: '全国',
    areaChoose: 0,
    leavethree: [],
    ctype: 4,
    cxingzhi: '',
    cprexiaoshou: '',
    page: 1,
    isShichang: true,
    leibie: '全部',
    // 市场信息列表
    city: '全国',
    infotype: '全部',
    isCountry: true,
    allChinese: '全部'
  },
  mutations: {
    SET_CHANGEMARKET (state, changeMarketType) {
      state.changeMarketType = changeMarketType
    },
    SET_MAREA (state, area) {
      state.area = area
    },
    SET_MARKETAREA (state, position) {
      state.position = position
    },
    SET_AREACHOOSE (state, areaChoose) {
      state.areaChoose = areaChoose
    },
    SET_LEAVETHREE (state, leavethree) {
      state.leavethree = leavethree
    },
    SET_CTYPE (state, ctype) {
      state.ctype = ctype
    },
    SET_CXINGZHI (state, cxingzhi) {
      state.cxingzhi = cxingzhi
    },
    SET_CPREXIAOSHOU (state, cprexiaoshou) {
      state.cprexiaoshou = cprexiaoshou
    },
    SET_PAGE (state, page) {
      state.page = page
    },
    SET_LEIBIE (state, leibie) {
      state.leibie = leibie
    },
    SET_CITY (state, city) {
      state.city = city
    },
    SET_INFOTYPE (state, infotype) {
      state.infotype = infotype
    },
    SET_ISSHICHANG (state, flag) {
      state.isShichang = flag
    },
    SET_ISCOUNTRY (state, flag) {
      state.isCountry = flag
    },
    SET_ALLCHINESE (state, value) {
      state.allChinese = value
    }
  }
}

export default changeMarketType



// WEBPACK FOOTER //
// ./src/store/modules/changeMarketType.js